export default __webpack_public_path__ + "static/media/manual-selection.866f8525.png";